import type { Container } from "@egalregal/shared";
import type { OwnCatalogEntry, SharedCatalogEntry } from "../../shared/api/requests";
import { entryIdOfContainer } from "./entryLabel";

/**
 * Whether the user may mutate placements in a container (item-placement-quantity
 * 01). Own entries are always writable; a shared entry is writable only at the
 * `write`/`admin` grant. When the entry cannot be resolved locally (an
 * unloaded slice or a plain local container) we let the server decide rather
 * than hiding a control that would work.
 */
export function canWriteContainer(
  containers: readonly Container[],
  entries: readonly OwnCatalogEntry[],
  sharedWithMe: readonly SharedCatalogEntry[],
  containerId: string,
  preferredEntryId?: string,
): boolean {
  const entryId = entryIdOfContainer(
    containers,
    entries,
    sharedWithMe,
    containerId,
    preferredEntryId,
  );
  if (entryId === undefined) return true;
  if (entries.some((entry) => entry.id === entryId)) return true;
  const shared = sharedWithMe.find((entry) => entry.entry.id === entryId);
  return shared ? shared.level === "write" || shared.level === "admin" : true;
}
